import * as React from 'react'

/**
 * Key press handler signature.
 */
export type OnKeyPressHandler = (e: KeyboardEvent) => unknown

/**
 * Registers a global key press handler.
 * @param handler
 */
export function useOnKeyDown(handler: OnKeyPressHandler) {
  React.useEffect(() => {
    window.addEventListener('keydown', handler)
    return () => {
      window.removeEventListener('keydown', handler)
    }
  }, [handler])
}

/**
 * Listens for `Esc` press.
 * @param handler
 */
export function useOnEscDown(handler: OnKeyPressHandler) {
  useOnKeyDown((e) => e.key === 'Escape' && handler(e))
}
